// socket.js
import { io } from "socket.io-client";
import { ip_back } from "./config";
import { useNavigate } from "react-router-dom";

let socket = null;

export const initializeSocket = (tokens) => {
  if (!socket) {
    socket = io(`${ip_back}`, {
      transportOptions: {
        polling: { extraHeaders: { Authorization: tokens } },
      },
    });

    socket.on("authError", (payload) => {
      const msg = payload?.message || "";
      const code = payload?.code;
      if (code === "TOKEN_EXPIRED" || /expired|invalid/i.test(msg)) {
        console.warn("🔒 Socket auth error (token expired/invalid) - redirecting to login");
        if (socket) {
          socket.removeAllListeners();
          socket.disconnect();
          socket = null;
        }
        localStorage.clear();
        sessionStorage.clear();
        if (window.location.pathname !== "/login") {
          window.location.href = "/login?expired=1";
        }
      }
    });
  }

  return socket;
};

// export const initializeSocket = (token) => {
//   if (!socket) {
//     socket = io("http://193.70.75.208:3030", {
//       auth: { token },
//       transports: ["websocket"],
//     });
//   }

//   return socket;
// };

export const joinRoom = ({ te_id, user_id }) => {
  if (socket) {
  }
};

export const listenToEvent = (eventName, callback) => {
  if (socket) {
    socket.on(eventName, callback);
  }
};
export const disconnectToEvent = (eventName, callback) => {
  if (socket) {
    socket.off(eventName);
  }
};

export const emitEvent = (eventName, data, callback) => {
  if (socket) {
    socket.emit(eventName, data, callback);
  }
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    console.log("disconnect");
    socket = null;
    // localStorage.clear();
  }
};

export const getSocket = () => socket;
